import { useEffect, useState, type ReactNode } from 'react'
import { AppContext, initialAppState } from './app-context'
import type { AppThemeMode } from '../theme'

const THEME_MODE_STORAGE_KEY = 'blackflag-theme-mode'

const getInitialThemeMode = (): AppThemeMode => {
  if (typeof window === 'undefined') {
    return initialAppState.themeMode
  }

  const storedThemeMode = window.localStorage.getItem(THEME_MODE_STORAGE_KEY)

  return storedThemeMode === 'light' || storedThemeMode === 'dark'
    ? storedThemeMode
    : initialAppState.themeMode
}

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState(() => ({
    ...initialAppState,
    themeMode: getInitialThemeMode(),
  }))

  useEffect(() => {
    window.localStorage.setItem(THEME_MODE_STORAGE_KEY, state.themeMode)
  }, [state.themeMode])

  const setThemeMode = (mode: AppThemeMode) => {
    setState((currentState) => ({
      ...currentState,
      themeMode: mode,
    }))
  }

  const toggleTheme = () => {
    setState((currentState) => ({
      ...currentState,
      themeMode: currentState.themeMode === 'dark' ? 'light' : 'dark',
    }))
  }

  return (
    <AppContext.Provider value={{ state, setState, setThemeMode, toggleTheme }}>
      {children}
    </AppContext.Provider>
  )
}
